<template>
  <main id="main-content" tabindex="-1" class="account__wrapper">
    <div class="account__container">
      <router-view></router-view>
    </div>
  </main>
</template>

<script>
export default {
  name: 'pigeon',
  created() {
    document.title = `Pigeon settings | ${this.$theme.theme.pageTitle}`;
  },
};
</script>
